const REDUX_LOCAL_KEY_PREFIX = '__'

const REDUX_LOCAL_KEY = {
  HAS_ASSOCIATION_CHANGE: '__localHasAssociationsChange',
  IS_DOWNLOADED: '__localIsDownloaded',
  IS_SUGGESTED: '__localIsSuggested',
  DATE: '__date'
}

export {
  REDUX_LOCAL_KEY,
  REDUX_LOCAL_KEY_PREFIX
}
